import { createSlice, isAnyOf } from "@reduxjs/toolkit";
import { getInventoryAdjustmentListAsync } from "../actions/omsPageActions";

interface InventoryAdjustmentItem {
  [key: string]: any;
}

interface PaginationState {
  pageNumber: number;
  count: number;
}

interface InventoryAdjustmentState {
  loading: boolean;
  adjustmentList: InventoryAdjustmentItem[];
  pagination: PaginationState;
}

const initialState: InventoryAdjustmentState = {
  loading: false,
  adjustmentList: [],
  pagination: {
    pageNumber: 1,
    count: 0,
  },
};

const inventoryAdjustmentSlice = createSlice({
  name: "inventoryAdjustmentSlice",
  initialState,
  reducers: {},
  extraReducers: (builder) => {
    builder.addMatcher(
      isAnyOf(getInventoryAdjustmentListAsync.pending),
      (state) => {
        state.loading = true;
      }
    );

    builder.addMatcher(
      isAnyOf(getInventoryAdjustmentListAsync.rejected),
      (state) => {
        state.loading = false;
      }
    );

    builder.addMatcher(
      isAnyOf(getInventoryAdjustmentListAsync.fulfilled),
      (state, action) => {
        state.loading = false;

        const res = action.payload;

        state.adjustmentList = res?.results?.data ?? [];
        state.pagination.count = res?.count ?? 0;

        state.pagination.pageNumber = action.meta.arg.page ?? 1;
      }
    );
  },
});

export default inventoryAdjustmentSlice.reducer;
